import { FileType, FileTypeName } from "@/enum/asset.enum"
import { request } from "../utils/request"


export const getAssets = (params: { page: number, limit: number, type?: FileType | undefined }): Promise<any> => {
    return new Promise((resolve) => {
        request.get('/assets', { params }).then((res) => {
            res.data.result.forEach((asset: { [x: string]: any; type: string }) => {
                asset['typeName'] = FileTypeName[asset.type]
            })
            return resolve(res)
        })
    })
}
